var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { PessoaFisicaApi } from '../../apis/pessoaFIsicaAPi';
import { SexoEnum } from '../../model/enums/SexoEnum';
import { isValidCpf, normalizeCpf } from './documentoValidators';
import { RequerentePf } from '../../model/RequerentePf';
import { ProfileEnum } from '../../model/enums/ProfileEnum';
export var handleBlurCpf = function (_a) {
    var _b = _a.profile, profile = _b === void 0 ? ProfileEnum.REQUERENTE_PF : _b, _c = _a.fieldError, fieldError = _c === void 0 ? 'cpfError' : _c, fieldErrorChange = _a.fieldErrorChange, _d = _a.isEdit, isEdit = _d === void 0 ? false : _d, setLoadingCpf = _a.setLoadingCpf, setHasCpfData = _a.setHasCpfData, fieldsErrors = _a.fieldsErrors, setCpfValid = _a.setCpfValid, setData = _a.setData, cpf = _a.cpf;
    return __awaiter(void 0, void 0, Promise, function () {
        var data, unformatedCpf, dados, sex, error_1;
        var _e, _f;
        var _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    _h.trys.push([0, 2, 3, 4]);
                    if (isEdit) {
                        return [2 /*return*/];
                    }
                    if (!cpf || !isValidCpf(cpf)) {
                        data = __assign(__assign({}, new RequerentePf()), { cpf: cpf, sexo: SexoEnum.MASCULINO });
                        setData === null || setData === void 0 ? void 0 : setData(__assign({}, data));
                        return [2 /*return*/];
                    }
                    setLoadingCpf(true);
                    unformatedCpf = cpf === null || cpf === void 0 ? void 0 : cpf.replace(/[.-]/g, '');
                    return [4 /*yield*/, PessoaFisicaApi.findByCpf(unformatedCpf).catch(function (error) {
                            var _a;
                            var _b, _c, _d;
                            fieldErrorChange === null || fieldErrorChange === void 0 ? void 0 : fieldErrorChange(__assign(__assign({}, fieldsErrors), (_a = {}, _a["".concat(fieldError)] = (_d = (_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : 'Erro ao buscar registro.', _a)));
                            var data = __assign(__assign({}, new RequerentePf()), { cpf: cpf, sexo: SexoEnum.MASCULINO });
                            setData === null || setData === void 0 ? void 0 : setData(__assign(__assign({}, data), { id: null }));
                            setLoadingCpf(false);
                        })];
                case 1:
                    dados = _h.sent();
                    if ((dados === null || dados === void 0 ? void 0 : dados.falecido) === true && profile !== ProfileEnum.FALECIDO_INVENTARIANTE) {
                        fieldErrorChange === null || fieldErrorChange === void 0 ? void 0 : fieldErrorChange(__assign(__assign({}, fieldsErrors), (_e = {}, _e["".concat(fieldError)] = 'Essa pessoa é falecida.', _e)));
                        setLoadingCpf(false);
                        return [2 /*return*/];
                    }
                    if (dados) {
                        sex = (_g = dados === null || dados === void 0 ? void 0 : dados.sexo) !== null && _g !== void 0 ? _g : SexoEnum.MASCULINO;
                        setData(__assign(__assign({}, dados), { id: null, cpf: normalizeCpf(dados === null || dados === void 0 ? void 0 : dados.cpf), sexo: sex }));
                        setHasCpfData === null || setHasCpfData === void 0 ? void 0 : setHasCpfData(true);
                        fieldErrorChange === null || fieldErrorChange === void 0 ? void 0 : fieldErrorChange(__assign(__assign({}, fieldsErrors), (_f = {}, _f["".concat(fieldError)] = '', _f)));
                        setCpfValid === null || setCpfValid === void 0 ? void 0 : setCpfValid(true);
                        return [2 /*return*/];
                    }
                    setHasCpfData === null || setHasCpfData === void 0 ? void 0 : setHasCpfData(false);
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _h.sent();
                    console.error('Erro ao buscar CPF:', error_1);
                    setLoadingCpf(false);
                    return [3 /*break*/, 4];
                case 3:
                    setLoadingCpf(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    });
};
